import React from 'react';
import './HygieneRatingBanner.css';

interface HygieneRatingBannerProps {}

const HygieneRatingBanner: React.FC<HygieneRatingBannerProps> = () => {
    return (
        <a
            href="https://ratings.food.gov.uk/business/1874096/"
            className="hygiene-banner"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Food Hygiene Rating 5 — Very Good"
        >
            <img
                src="/images/badges/badge2.svg"
                alt="Food Hygiene Rating 5 — Very Good"
                className="hygiene-banner-badge"
            />
        </a>
    );
};

export default HygieneRatingBanner;
